/* global debounce */

if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.js-search-input');
      this.productTypeSelect = this.querySelector('.js-search-product-types');
      this.productTypeInput = this.querySelector('.js-product-type-input');
      this.searchTypeInput = this.querySelector(
  '.js-search-type-input'
);

this.defaultSearchTypes = this.searchTypeInput
  ? this.searchTypeInput.value
  : '';
      this.resetBtn = this.querySelector('.js-search-reset');
      this.form =
  this.querySelector('form') ||
  this.closest('form');

this.languageCode = (
  document.documentElement.lang || ''
)
  .split('-')[0]
  .toLowerCase();
      this.addListeners();
      this.init();
    }

    addListeners() {
      this.input.addEventListener('input', debounce(this.handleInput.bind(this)));
      if (this.productTypeSelect) {
        this.productTypeSelect.addEventListener('change', this.handleProductTypeChange.bind(this));
      }
      this.resetBtn.addEventListener('click', this.handleReset.bind(this));
      if (this.form) {
  this.form.addEventListener(
    'submit',
    this.handleSubmit.bind(this)
  );
}
    }

    init() {
  const isRedirecting =
    this.normalizeSearchUrlForLocale();

  if (isRedirecting) {
    return;
  }

  this.sortProductTypeOptions();

  this.restoreItalianProductTypeQuery();

  if (
    (
      this.input.dataset.placeholderTwo ||
      this.input.dataset.placeholderThree
    ) &&
    (
      this.input.dataset.placeholderPromptsMob === 'true' ||
      theme.mediaMatches.md
    )
  ) {
    this.typeInPlaceholders();
  }
}

/**
 * Converte automaticamente l'URL della ricerca
 * quando viene cambiata la lingua.
 *
 * Italiano:
 * q=product_type:Pochette AND blu
 *
 * Inglese:
 * q=blu&filter.p.product_type=Pochette
 */
normalizeSearchUrlForLocale() {
  const isSearchPage =
    /\/search\/?$/.test(
      window.location.pathname
    );

  if (!isSearchPage) {
    return false;
  }

  /*
   * Nella pagina possono esserci più search-form:
   * uno nell'header e uno nella ricerca centrale.
   * Questo controllo impedisce doppi redirect.
   */
  if (window.__searchLocaleUrlNormalized) {
    return false;
  }

  const languageCode = (
    document.documentElement.lang || ''
  )
    .split('-')[0]
    .toLowerCase();

  const params =
    new URLSearchParams(
      window.location.search
    );

  const currentQuery =
    params.get('q') || '';

  const productTypeFilter =
    params.get(
      'filter.p.product_type'
    ) || '';

  /*
   * Individua la query tecnica italiana:
   * product_type:Pochette AND blu
   */
  const technicalQueryMatch =
    currentQuery.match(
      /^product_type:(.+?)\s+AND\s+(.+)$/i
    );

  /*
   * Passaggio ITALIANO → INGLESE.
   *
   * Trasforma:
   * q=product_type:Pochette AND blu
   *
   * in:
   * q=blu
   * filter.p.product_type=Pochette
   */
  if (
    languageCode === 'en' &&
    technicalQueryMatch
  ) {
    const productType =
      technicalQueryMatch[1].trim();

    const cleanQuery =
      technicalQueryMatch[2].trim();

    params.set(
      'filter.p.product_type',
      productType
    );

    if (cleanQuery) {
      params.set('q', cleanQuery);
    } else {
      params.delete('q');
    }

    params.set('type', 'product');
    params.delete('page');

    window.__searchLocaleUrlNormalized =
      true;

    window.location.replace(
      `${window.location.pathname}?${params.toString()}`
    );

    return true;
  }

  /*
   * Passaggio INGLESE → ITALIANO.
   *
   * Trasforma:
   * q=blu
   * filter.p.product_type=Pochette
   *
   * in:
   * q=product_type:Pochette AND blu
   */
  if (
    languageCode === 'it' &&
    productTypeFilter &&
    !technicalQueryMatch
  ) {
    const cleanQuery =
      currentQuery.trim();

    const technicalQuery =
      cleanQuery
        ? `product_type:${productTypeFilter} AND ${cleanQuery}`
        : `product_type:${productTypeFilter}`;

    params.set('q', technicalQuery);

    params.delete(
      'filter.p.product_type'
    );

    params.set('type', 'product');
    params.delete('page');

    window.__searchLocaleUrlNormalized =
      true;

    window.location.replace(
      `${window.location.pathname}?${params.toString()}`
    );

    return true;
  }

  return false;
}

/**
     * Ordina alfabeticamente i tipi prodotto
     * usando il testo effettivamente mostrato.
     * Tutto / All rimane sempre come prima voce.
     */
    sortProductTypeOptions() {
      if (!this.productTypeSelect) return;

      const listbox = this.productTypeSelect.querySelector(
        '.custom-select__listbox'
      );

      if (!listbox) return;

      const allOptions = [
        ...listbox.querySelectorAll('.js-option')
      ];

      const defaultOption = allOptions.find(
        option => (option.dataset.value || '') === ''
      );

      const productTypeOptions = allOptions.filter(
        option => (option.dataset.value || '') !== ''
      );

      const currentLocale =
  document.documentElement.lang || 'it';

const preferredOrder = [
  ['cravatta', 'cravatte', 'neckties'],
  ['costume', 'costumi', 'swimwear', 'suits'],
  ['pochette'],
  ['foulard', 'headscarves'],
  ['bretelle', 'braces', 'suspenders'],
  ['gemelli', 'cufflinks'],
  ['cintura', 'cinture', 'belts'],
  ['borsa', 'borse', 'bags']
];

const normalizeValue = (value) => {
  return (value || '')
    .trim()
    .toLowerCase();
};

const getPriorityIndex = (option) => {
  const technicalValues = (
    option.dataset.value || ''
  )
    .split(',')
    .map((value) => normalizeValue(value));

  return preferredOrder.findIndex((group) =>
    group.some((value) =>
      technicalValues.includes(normalizeValue(value))
    )
  );
};

productTypeOptions.sort((firstOption, secondOption) => {
  const firstPriority =
    getPriorityIndex(firstOption);

  const secondPriority =
    getPriorityIndex(secondOption);

  if (
    firstPriority !== -1 &&
    secondPriority !== -1
  ) {
    return firstPriority - secondPriority;
  }

  if (firstPriority !== -1) {
    return -1;
  }

  if (secondPriority !== -1) {
    return 1;
  }

  const firstLabel =
    firstOption.textContent.trim();

  const secondLabel =
    secondOption.textContent.trim();

  return firstLabel.localeCompare(
    secondLabel,
    currentLocale,
    {
      sensitivity: 'base',
      numeric: true
    }
  );
});

      const fragment = document.createDocumentFragment();

      if (defaultOption) {
        fragment.appendChild(defaultOption);
      }

      productTypeOptions.forEach((option) => {
        fragment.appendChild(option);
      });

      listbox.appendChild(fragment);
    }


    /**
 * Elimina dalla parte visibile la sintassi tecnica:
 * product_type:Pochette AND blu
 * diventa:
 * blu
 */
getCleanSearchQuery(query) {
  return (query || '')
    .replace(
      /^product_type:.+?\s+AND\s+/i,
      ''
    )
    .trim();
}

/**
 * Aggiorna graficamente il custom select.
 * Usa il testo già tradotto presente nell'opzione.
 */
selectProductTypeOption(selectedValue) {
  if (!this.productTypeSelect) return;

  const normalizedSelectedValue =
    (selectedValue || '')
      .trim()
      .toLowerCase();

  const options = [
    ...this.productTypeSelect.querySelectorAll(
      '.js-option'
    )
  ];

  const selectedOption = options.find((option) => {
    const technicalValues = (
      option.dataset.value || ''
    )
      .split(',')
      .map((value) =>
        value.trim().toLowerCase()
      );

    return technicalValues.includes(
      normalizedSelectedValue
    );
  });

  if (!selectedOption) return;

  options.forEach((option) => {
    option.removeAttribute('aria-selected');
  });

  selectedOption.setAttribute(
    'aria-selected',
    'true'
  );

  const button =
    this.productTypeSelect.querySelector(
      '.custom-select__btn'
    );

  const buttonText = button
    ? button.querySelector('.text-start')
    : null;

  const optionTextElement =
    selectedOption.querySelector('span');

  const optionText = optionTextElement
    ? optionTextElement.textContent.trim()
    : selectedOption.textContent.trim();

  if (buttonText) {
    buttonText.textContent = optionText;
  }

  const listbox =
    this.productTypeSelect.querySelector(
      '.custom-select__listbox'
    );

  if (listbox && selectedOption.id) {
    listbox.setAttribute(
      'aria-activedescendant',
      selectedOption.id
    );
  }
}

/**
 * Legge il Product Type dalla query tecnica italiana
 * e ripristina tendina e testo visibile.
 */
restoreItalianProductTypeQuery() {
  const isSearchPage =
    /\/search\/?$/.test(
      window.location.pathname
    );

  if (
    this.languageCode !== 'it' ||
    !isSearchPage ||
    !this.productTypeInput
  ) {
    return;
  }

  const params = new URLSearchParams(
    window.location.search
  );

  const technicalQuery =
    params.get('q') || '';

  const match = technicalQuery.match(
    /^product_type:(.+?)\s+AND\s+(.+)$/i
  );

  if (!match) return;

  const selectedProductType =
    match[1].trim();

  const visibleQuery =
    match[2].trim();

  this.productTypeInput.value =
    selectedProductType;

  this.input.value = visibleQuery;

  this.input.setAttribute(
    'value',
    visibleQuery
  );

  this.input.classList.toggle(
    'search__input--dirty',
    visibleQuery.length > 0
  );

  if (this.searchTypeInput) {
    this.searchTypeInput.value = 'product';
  }

  this.selectProductTypeOption(
    selectedProductType
  );
}

/**
 * In italiano invia il Product Type dentro q,
 * senza inviare filter.p.product_type.
 */
handleSubmit(event) {
  if (
    this.languageCode !== 'it' ||
    !this.form ||
    !this.productTypeInput
  ) {
    return;
  }

  const predictiveSearch =
    this.closest('predictive-search');

  const selectedSuggestion =
    predictiveSearch
      ? predictiveSearch.querySelector(
          '.predictive-search__item[aria-selected="true"]:not(.js-submit)'
        )
      : null;

  if (selectedSuggestion) return;

  const selectedProductType =
    this.productTypeInput.value.trim();

  if (!selectedProductType) return;

  const cleanQuery =
    this.getCleanSearchQuery(
      this.input.value
    );

  if (!cleanQuery) return;

  event.preventDefault();

  const formData =
    new FormData(this.form);

  formData.delete(
    'filter.p.product_type'
  );

  formData.set(
    'q',
    `product_type:${selectedProductType} AND ${cleanQuery}`
  );

  formData.set('type', 'product');

  if (!formData.has('options[prefix]')) {
    formData.set(
      'options[prefix]',
      'last'
    );
  }

  const searchParams =
    new URLSearchParams();

  formData.forEach((value, key) => {
    if (
      typeof value === 'string' &&
      value !== ''
    ) {
      searchParams.append(key, value);
    }
  });

  const actionUrl = new URL(
    this.form.getAttribute('action') ||
      window.location.pathname,
    window.location.origin
  );

  actionUrl.search =
    searchParams.toString();

  window.location.assign(
    actionUrl.toString()
  );
}
    

    /**
     * Simulates the placeholder titles being typed in and the previous one deleted, on repeat
     */
    typeInPlaceholders() {
      const typingSpeed = this.input.dataset.typingSpeed || 100;
      const deletingSpeed = this.input.dataset.deletingSpeed || 60;
      const delayAfterDeleting = this.input.dataset.delayAfterDeleting || 500;
      const delayBeforeFirstDelete = this.input.dataset.delayBeforeFirstDelete || 2000;
      const delayAfterWordTyped = this.input.dataset.delayAfterWordTyped || 2400;
      const placeholders = [];

      if (this.input.placeholder) {
        placeholders.push(this.input.placeholder);
      }

      if (this.input.dataset.placeholderTwo) {
        placeholders.push(this.input.dataset.placeholderTwo);
      }

      if (this.input.dataset.placeholderThree) {
        placeholders.push(this.input.dataset.placeholderThree);
      }

      const typeInNextPlaceholder = async (placeholder) => {
        await new Promise((resolve) => {
          let currentPlaceholder = this.input.getAttribute('placeholder');

          // If necessary remove the start of the word to type in if it already exists in the
          // placeholder
          let nextPlaceholder = (currentPlaceholder.length >= 3
              && placeholder.startsWith(currentPlaceholder))
            ? placeholder.replace(currentPlaceholder, '')
            : placeholder;

          const typingIntervalId = setInterval(() => {
            currentPlaceholder = this.input.getAttribute('placeholder');
            this.input.setAttribute('placeholder', currentPlaceholder + nextPlaceholder.charAt(0));
            if (nextPlaceholder.length === 1) {
              resolve();
              clearInterval(typingIntervalId); // Stop typing
            } else {
              nextPlaceholder = nextPlaceholder.substring(1);
            }
          }, typingSpeed);
        });
      };

      const deleteCurrentPlaceholder = async (nextPlaceholder) => {
        await new Promise((resolve) => {
          let prevPlaceholder = this.input.getAttribute('placeholder');
          const deletionIntervalId = setInterval(() => {
            const newPlaceholder = prevPlaceholder.substring(0, prevPlaceholder.length - 1);
            this.input.setAttribute('placeholder', newPlaceholder);
            prevPlaceholder = newPlaceholder;
            if (prevPlaceholder.length === 0
              || (prevPlaceholder.length >= 3 && nextPlaceholder.startsWith(prevPlaceholder))) {
              resolve();
              clearInterval(deletionIntervalId);
            }
          }, deletingSpeed);
        });
      };

      let startIndex = 0;
      const showNextPlaceholder = () => {
        startIndex = (startIndex + 1) % placeholders.length;
        const nextPlaceholder = placeholders[startIndex];
        deleteCurrentPlaceholder.call(this, nextPlaceholder).then(() => {
          setTimeout(() => {
            typeInNextPlaceholder.call(this, nextPlaceholder).then(() => {
              setTimeout(showNextPlaceholder.bind(this), delayAfterWordTyped);
            });
          }, delayAfterDeleting);
        });
      };

      setTimeout(showNextPlaceholder.bind(this), delayBeforeFirstDelete);
    }

    /**
     * Handles 'input' events on the search field.
     */
    handleInput() {
      if (this.input.value.length > 0) {
        this.input.classList.add('search__input--dirty');
      } else {
        this.input.classList.remove('search__input--dirty');
      }
    }

    /**
     * Handles a change of product type
     * @param {object} evt - Event object.
     */
    handleProductTypeChange(evt) {
  if (!this.productTypeInput) return;

  const selectedValue =
    evt.detail.selectedValue || '';

  this.productTypeInput.value =
    selectedValue;

  if (this.searchTypeInput) {
    this.searchTypeInput.value =
      selectedValue !== ''
        ? 'product'
        : this.defaultSearchTypes;
  }
}

    /**
     * Handles the reset button being clicked
     */
    handleReset() {
      this.input.classList.remove('search__input--dirty');
    }
  }

  customElements.define('search-form', SearchForm);
}
